import React from "react";
import styles from "./PublicNavigation.module.scss";
import classNames from "classnames";
import { Link } from "react-router-dom";

const PublicNavigation = () => {
  return (
    <nav className={classNames(styles.navbar)}>
      <div className={styles.logoContainer}>
        <h1>Aware Technology</h1>
      </div>

      <ul className={classNames(styles.navbarContainer)}>
        {/* <li>
          <Link to="/">Product</Link>
        </li>
        <li>
          <Link to="/about">About</Link>
        </li>
        <li>
          <Link to="/about">My Class</Link>
        </li>
        <li>
          <Link to="/about">Pricing</Link>
        </li>
        <li>
          <Link to="/about">Request a Demo</Link>
        </li> */}
      </ul>
    </nav>
  );
};

export default PublicNavigation;
